/* tslint:disable:jsx-no-lambda */
import DeepLinkMailView from './DeepLinkMailView';
import DeepLinkPeoplePickerView from './DeepLinkPeoplePickerView';
import DeepLinkInboxForMeView from './DeepLinkInboxForMeView';
import DeepLinkSproutView from './DeepLinkSproutView';
import { observer } from 'mobx-react-lite';
import Droppable from 'owa-dnd/lib/components/Droppable';
import createDropViewState from 'owa-dnd/lib/utils/createDropViewState';
import { ImmersiveReaderContainer } from 'owa-immersive-reader';
import { isFeatureEnabled } from 'owa-feature-flags';
import { lazyResetFocus } from 'owa-mail-focus-manager';
import setTypeOfItemBeingDragged from 'owa-mail-store/lib/actions/setTypeOfItemBeingDragged';
import store from 'owa-mail-store/lib/store/Store';
import * as React from 'react';
import { lazySetupUndoHotKeys } from 'owa-mail-hotkeys';
import { useLazyKeydownHandler } from 'owa-hotkeys';
import { SearchAnswer } from 'owa-search-answer-deeplink';
import { SaveToCloudTab } from 'owa-attachment-savetocloud-deeplink';
import { SxSDeeplink } from 'owa-attachment-sxs-deeplink';
import { useDragHelpers } from 'owa-mail-module-view/lib/components/hooks/useDragHelpers';

import styles from 'owa-mail-module-view/lib/components/MailModule.scss';
import DeepLinkDownloadMobileView from './DeepLinkDownloadMobileView';

export interface DeepLinkModuleProps {
    subRoute: string;
}

export default observer(function DeepLinkModule(props: DeepLinkModuleProps) {
    React.useEffect(() => {
        // Set initial focus after component is mounted
        lazyResetFocus.importAndExecute();
        // Override min-width on the global style after mount.
        document.body.style.minWidth = '0';
    }, []);
    // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
    // -> Error TS2345 (39,40): Argument of type '(newValue: string) => void' is not assignable to parameter of type '(newValue: string | null) => void'.
    // @ts-expect-error
    const dragHelpers = useDragHelpers(setDataItemType);
    useLazyKeydownHandler(undefined, lazySetupUndoHotKeys.importAndExecute, undefined);

    switch (props.subRoute) {
        case 'attachment':
            return <SxSDeeplink />;
        case 'saveAndEdit':
            return <SaveToCloudTab />;
        case 'searchAnswer':
            return <SearchAnswer />;
        case 'sprout':
            return <DeepLinkSproutView />;
        case 'peoplepicker':
            return <DeepLinkPeoplePickerView />;
        case 'inboxForMe':
            return <DeepLinkInboxForMeView />;
        case 'downloadmobile': {
            return <DeepLinkDownloadMobileView />;
        }
        default:
            const emptyDropViewState = createDropViewState();

            return (
                <>
                    <Droppable
                        classNames={styles.mailMain}
                        {...dragHelpers}
                        dropViewState={emptyDropViewState}
                        shouldIgnoreTransientOnDragLeave={true}>
                        <div className={styles.allPaneContainer}>
                            <DeepLinkMailView
                                isItemAttachment={props.subRoute === 'itemattachment'}
                            />
                        </div>
                    </Droppable>
                    {!isFeatureEnabled('rp-immersiveReaderv2') && <ImmersiveReaderContainer />}
                </>
            );
    }
});

function setDataItemType(newValue: string) {
    if (store.typeOfItemBeingDragged != newValue) {
        setTypeOfItemBeingDragged(newValue);
    }
}
